import React from 'react';

import { useTranslation } from 'react-i18next';

import TaxFormsTable from 'src/modules/tax-forms/components/tax-form-table';
import {
  Container,
  ScreenHeader,
  PageTitle,
  CardContainer,
  CardContent,
  LeftHeader,
  CardTitle,
  CardHeader,
} from './styles';

const TaxForms: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <ScreenHeader>
        <PageTitle>{t('taxForms.pageTitle')}</PageTitle>
      </ScreenHeader>
      <CardContainer>
        <CardHeader>
          <LeftHeader>
            <CardTitle>{t('taxForms.listTitle')}</CardTitle>
          </LeftHeader>
        </CardHeader>
        <CardContent>
          <TaxFormsTable />
        </CardContent>
      </CardContainer>
    </Container>
  );
};

export default TaxForms;
